import { PersistedMetamodel } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import {
  MetamodelContextSettingMap,
  MetamodelEntityContext,
  SelectedMetamodelItem,
} from 'metamodel/types';

export const selectMetamodelForSlide = actionCreator<PersistedMetamodel>(
  '[navigation] SELECT_METAMODEL_FOR_SLIDE'
);

export const selectMetamodelItem = actionCreator<SelectedMetamodelItem>(
  '[navigation] SELECT_METAMODEL_ITEM'
);

export const setMetamodelContext = actionCreator<MetamodelEntityContext>(
  '[navigation] SET_METAMODEL_CONTEXT'
);

export const setMetamodelContextSettings =
  actionCreator<MetamodelContextSettingMap>(
    '[navigation] SET_METAMODEL_CONTEXT_SETTINGS'
  );

export const setMetamodelInfoContainerIsOpen = actionCreator<boolean>(
  '[navigation] SET_METAMODEL_INFO_CONTAINER_IS_OPEN'
);
